module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), (_vm.clientID > 0) ? _c('b-button', {
    staticClass: "mb-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.getJobHistory(_vm.clientID)
      }
    }
  }, [_vm._v("Job History")]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "JobHistory-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.Page_title
    }
  }, [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [(_vm.JobHistoryList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getJobHistoryList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.ExcelBtnName) + "\n          "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.JobHistoryList,
      "fields": _vm.JobHistoryfields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "JOBNO",
      fn: function(row1) {
        return [_c('span', [_vm._v("JOB No : " + _vm._s(row1.item.JOBNO)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("JOB Date : " + _vm._s(row1.item.JOBDate)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Job Type : " + _vm._s(row1.item.JOBTYPE)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Shipment Type : " + _vm._s(row1.item.shipmentType)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Transport Type : " + _vm._s(row1.item.transportType)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.Branch)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Raised By : " + _vm._s(row1.item.RaisedBy)), _c('br')]), _vm._v(" "), (row1.item.allModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row1.item.JOBNO,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.JOBNO,
            "PMC_JOBDATE": row1.item.JOBDate,
            "PMC_JOBTYPE": row1.item.JOBTYPE,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.clientName,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.JOBNO,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.JOBNO,
            "PMC_JOBDATE": row1.item.JOBDate,
            "PMC_JOBTYPE": row1.item.JOBTYPE,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.clientName,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e()]
      }
    }, {
      key: "shippingLine",
      fn: function(row2) {
        return [_c('span', [_vm._v(" Client : " + _vm._s(row2.item.clientName)), _c('br')]), _vm._v(" "), _c('span', [_vm._v(" Sline : " + _vm._s(row2.item.shippingLine)), _c('br')])]
      }
    }, {
      key: "POR",
      fn: function(row3) {
        return [_c('span', [_vm._v("No Of Cont. : " + _vm._s(row3.item.multiConNo)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Cont. Type : " + _vm._s(row3.item.multipleContainerType)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("MBL : " + _vm._s(row3.item.MBLNO)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("HBL : " + _vm._s(row3.item.HBLNO)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Booking No : " + _vm._s(row3.item.BookingNo)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Payment Status : " + _vm._s(row3.item.oe_payment_status)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Payment Date : " + _vm._s(row3.item.oe_payment_date_first)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("PICK : " + _vm._s(row3.item.PICK)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("STUFF : " + _vm._s(row3.item.STUFF)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("HAND : " + _vm._s(row3.item.HAND)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("POR : " + _vm._s(row3.item.POR)), _c('br')]), _vm._v(" "), (row3.item.JOBTYPE.split(',').includes('FF')) ? _c('div', [_c('span', [_vm._v("POL : " + _vm._s(row3.item.POL)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("POD : " + _vm._s(row3.item.POD)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("FPOD : " + _vm._s(row3.item.FPOD)), _c('br')])]) : _vm._e()]
      }
    }, {
      key: "allModuleId",
      fn: function(row4) {
        return [_c('span', [_vm._v("ENQ No. : " + _vm._s(row4.item.ENQNO)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("ENQ Type : " + _vm._s(row4.item.ENQTYPE) + "(" + _vm._s(row4.item.shipmentType) + "\n              " + _vm._s(row4.item.transportType) + ")"), _c('br')]), _vm._v(" "), _c('span', [_vm._v("ENQ Date : " + _vm._s(row4.item.ENQDATE))])]
      }
    }, {
      key: "isConsolidation",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s(row5.item.isConsolidation))])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideJobHistoryModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-650d3e84","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/moduleBasedClientJobs.vue
// module id = 2690
// module chunks = 0